const HeaderCheckbox = (props) => {
    const parentIds = props.context.allRows
        .filter((x) => x.type === "parent")
        .map((x) => x.id);

    const allSelected =
        parentIds.length > 0 &&
        parentIds.every((id) =>
            props.context.selectedOrderIds.includes(id)
        );

    return (
        <input
            type="checkbox"
            checked={allSelected}
            onChange={(e) => {
                if (e.target.checked) {
                    props.context.setSelectedOrderIds(parentIds);
                } else {
                    props.context.setSelectedOrderIds([]);
                }
            }}
        />
    );
};
export default HeaderCheckbox;